<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Document Preview</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body text-center">

  <div *ngIf="!thumbnailLoaded" class="d-flex justify-content-center py-4">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <img *ngIf="thumbnailLoaded"
       [src]="'data:image/png;base64,' + thumbnailData"
       alt="Preview Document"
       class="img-fluid">

</div>